<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-button type="primary" @click="showAddRecord = true"
                >添加数据趋势
                </el-button
                >
                <el-button type="primary" @click="onSubmit"
                >刷新数据趋势
                </el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            @sort-change="handleSortChange"
            style="width: 100%;"
        >
            <el-table-column label="ID" width="80" align="center" fixed>
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="日耗"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.daily_budget || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="bid系数"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.bid_coefficient || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="res 订单数(大等于)" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.res_orders || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="res 订单数(小等于)" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.res_orders_lt || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="res acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.res_acos || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="phrase-res订单数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.phrase_res_orders || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="phrase-res Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.phrase_res_acos || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="asin订单数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin_orders || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="asin Acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin_acos || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="per 订单数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.per_orders || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="per acos" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.per_acos || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="词根" min-width="220" align="center">
                <template slot-scope="scope">

                    <el-tag v-for="(tag, index) in (scope.row.extra_root_words || [])"
                            size="mini" :key="index" style="margin:0 10px 10px 0">
                        {{tag}}
                    </el-tag>

                </template>
            </el-table-column>
            <el-table-column label="SKU" min-width="220" align="center">
                <template slot-scope="scope">
                    <el-tag v-for="(tag, index) in (scope.row.setting_skus || [])"
                            size="mini" :key="index" style="margin:0 10px 10px 0">
                        {{tag}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="备注" min-width="220" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.remark || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="开始日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="结束日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300" fixed="right">
                <template slot-scope="scope">
                    <!--<el-button-->
                    <!--v-if="scope.row.status === -1"-->
                    <!--@click="startDecode(scope.row, 1)"-->
                    <!--style="margin: 5px 0 5px 10px"-->
                    <!--type="danger"-->
                    <!--size="mini"-->
                    <!--&gt;{{-->
                    <!--scope.row.parsing_err_msg || "解析失败"-->
                    <!--}}</el-button-->
                    <!--&gt;-->
                    <el-button
                        v-if="scope.row.status === -1"
                        type="danger"
                        size="mini"
                        @click="showErrorInfo(scope.row)"
                    >查看完整错误信息
                    </el-button>
                    <el-button
                        v-if="scope.row.status === 0"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row)"
                    >开始解析
                    </el-button
                    >
                    <el-button
                        v-if="scope.row.status === 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                    >解析中
                    </el-button
                    >
                    <el-button
                        v-if="scope.row.status === 2"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        @click="downFile(scope.row.parsing_path)"
                        size="mini"
                    >下载解析
                    </el-button
                    >
                    <el-button
                        v-if="scope.row.status !== 0 && scope.row.status !== 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row, 1)"
                    >重新解析
                    </el-button
                    >
                    <!--<el-button-->
                    <!--style="margin: 5px 0 5px 10px"-->
                    <!--type="success"-->
                    <!--@click="update(scope.row)"-->
                    <!--size="mini"-->
                    <!--&gt;更新</el-button-->
                    <!--&gt;-->
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_file(scope.row)"
                    >删除
                    </el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <addDataTrend
            :visible="showAddRecord"
            v-if="showAddRecord"
            :title="updateData.id ? '更新数据趋势列' : '添加数据趋势列'"
            :formData="updateData"
            @close-callback="closeCllback"
        ></addDataTrend>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; padding-bottom: 30px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <el-dialog
            style="padding: 0 20px 20px 20px !important;"
            width="30%"
            center
            title="错误信息"
            v-if="errorInfoShow"
            :visible.sync="errorInfoShow"
        >
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
                <!--<el-button @click="errorInfoShow = false">取 消</el-button>-->
                <el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import * as api from '@/api/statistics/statistics'
    import Upload from './newupload'
    import addDataTrend from './addDataTrend'
    import DownloadList from '../downloadList'
    import DownloadView from '../downloadView'
    import BidList from '../bidList.vue'
    import AddPpc from '../addPpc'
    import {downloadFileUrl} from '@/utils/method'

    let timer = null
    export default {
        components: {
            Upload,
            DownloadList,
            DownloadView,
            AddPpc,
            BidList,
            addDataTrend
        },
        data() {
            return {
                showAddRecord: false,
                currentId: '',
                tableHeight: null,
                errorMsg: '',
                errorInfoShow: false,
                ctrl: {
                    DownloadListDialogVisible: false,
                    addPpcDialogVisible: false,
                    uploadDialogVisible: false,
                    bidDialogVisible: false
                },
                typeArr: [
                    {
                        index: 1,
                        title: '广告层面'
                    },
                    {
                        index: 2,
                        title: '逻辑层面'
                    }
                ],
                us_arr: [
                    {
                        us: 'us',
                        title: '美国'
                    },
                    {
                        us: 'uk',
                        title: '英国'
                    },
                    {
                        us: 'de',
                        title: '德国'
                    }
                ],
                query: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    ad_portfolio_name_id: '',
                    res_orders_lt: '',
                    phrase_res_orders: '',
                    phraser_res_acos: '',
                },
                record_id: 0,
                activeName: 'antiInternal',
                list: [],
                disabled: false,
                listDisabled: false,
                loading: false,
                parseStatusList: [],
                updateData: {}
            }
        },
        created() {
            this.query.ad_portfolio_name_id = this.$route.query.ad_portfolio_name_id
            this.query.state = this.$route.query.state
            this.query.asin = this.$route.query.asin
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 710 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            710 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
            this.getList()
        },
        watch: {
            tableHeight(val) {
                this.tableHeight = val
            }
        },
        destroyed() {
            clearInterval(timer)
        },
        methods: {
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.parsing_err_msg
            },
            getList() {
                this.loading = true
                api.get_data_trend({
                    page: this.query.page,
                    limit: this.query.limit,
                    state: this.query.state,
                    asin: this.query.asin,
                    res_orders_lt: this.query.res_orders_lt,
                    phrase_res_orders: this.query.phrase_res_orders,
                    phraser_res_acos: this.query.phraser_res_acos
                })
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.list = res.data.list
                            this.query.total = res.data.total
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            handleSortChange(val) {
                if (val.order == 'ascending') {
                    this.query.desc = 'desc'
                    this.query.order = val.prop
                } else if (val.order == 'descending') {
                    this.query.desc = 'asc'
                    this.query.order = val.prop
                }
                this.getList()
            },
            handleClick(tab) {
                this.$nextTick(() => {
                    this.$refs[tab.paneName].getList()
                })
            },
            //重置
            onReset() {
                this.query.project_name = ''
                this.query.state = ''
                this.query.order = ''
                this.query.desc = ''
                this.query.page = 1
                this.getList()
            },
            //查询
            onSubmit() {
                this.getList()
            },
            change() {
                this.getList()
            },
            clearValue() {
                this.query.state = ''
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            //上传文件
            onupload() {
                this.ctrl.uploadDialogVisible = true
            },
            //下载列表
            onDownloadList() {
                this.ctrl.DownloadListDialogVisible = true
                this.$nextTick(() => {
                    this.$refs[this.activeName].getList()
                })
            },
            // bid记录列表
            openBidList(data) {
                console.log('data', data)
                this.currentId = data.id
                this.ctrl.bidDialogVisible = true
            },
            async startDecode(row, force = 0) {
                if (force) {
                    await this.$confirm('是否重新运行解析任务', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }
                let list = JSON.parse(JSON.stringify(this.list))
                api.parse_data_trend({
                    id: row.id,
                    force
                }).then(res => {
                    if (res.code === 0) {
                        const index = list.findIndex(item => item.id === row.id)
                        list[index].status = 1
                        this.list = list
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            //添加广告优化记录
            onAddPpc(data) {
                this.record_id = data.id
                this.ctrl.addPpcDialogVisible = true
            },
            //删除
            delete_file(data) {
                this.$confirm(`确定要删除这条记录吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        api.delete_data_trend({
                            id: data.id
                        })
                            .then(res => {
                                if (res.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: '删除成功'
                                    })
                                    this.getList()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(res => {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                })
                            })
                    })
                    .catch(() => {
                    })
            },
            // 关闭弹窗回调
            closeCllback(isshow) {
                this.showAddRecord = false
                this.updateData = {}
                isshow == true && this.getList()
            },
            update(data) {
                this.updateData = data
                this.showAddRecord = true
            }
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }
</style>
